/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Model, { attr } from '@ember-data/model';

export default class FinUsageLimit extends Model {
  @attr('number') declare threshold: number;
  @attr('boolean') declare enabled: boolean;
  @attr('boolean') declare limited: boolean;
}
